module.exports = __webpack_public_path__ + "assets/img/pythree.1ef68cf3.png";